import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';

interface GoogleSheetsStatus {
  has_token: boolean;
  sheet_url: string;
  has_action: boolean;
}

/**
 * Hook to get the Google Sheets connection status for AI Actions.
 * Returns has_token, the connected sheet URL, and whether the logging action still exists.
 *
 * The queryFn and staleTime live on the queryClient default registered for
 * `[QueryKey.integration.googleSheetsStatus]` in `Config/api/queryClient.ts`.
 */
export const useGoogleSheetsStatus = () =>
  useQuery<GoogleSheetsStatus>({
    queryKey: [QueryKey.integration.googleSheetsStatus],
  });
